/**
 * Semantic Typography Types
 * Defines the contract for the typography system.
 */

export type FontWeight =
  | "normal"
  | "bold"
  | "100"
  | "200"
  | "300"
  | "400"
  | "500"
  | "600"
  | "700"
  | "800"
  | "900";

export interface FontStyles {
  color: string;
  fontFamily: string;
  fontSize: number;
  lineHeight: number;
  fontWeight: FontWeight;
  letterSpacing: number;
}

export interface TypographySizeVariants {
  regular: FontStyles;
  emphasized: FontStyles;
  bold: FontStyles;
}

export interface TypographySizes {
  large: TypographySizeVariants;
  medium: TypographySizeVariants;
  small: TypographySizeVariants;
}

export interface TypographyTheme {
  display: TypographySizes;
  headline: TypographySizes;
  title: TypographySizes;
  label: TypographySizes;
  body: TypographySizes;
}

export interface WebFontStyles {
  color: string;
  fontFamily: string;
  fontSize: string;
  lineHeight: number;
  fontWeight: string;
  letterSpacing: string;
}

export function toWebStyles(styles: FontStyles): WebFontStyles {
  return {
    color: styles.color,
    fontFamily: styles.fontFamily,
    fontSize: `${styles.fontSize / 16}rem`,
    lineHeight: styles.lineHeight / styles.fontSize,
    fontWeight: styles.fontWeight,
    letterSpacing: `${styles.letterSpacing / 16}rem`,
  };
}
